import { transformToOption } from '../../../../../../utils/functional/fp';
import { QuoteStatus } from '../../../../../_statics/quote.statics';

export const QUOTE_ACTIONS = Object.freeze({
  RELEASE: 'UW_RELEASE_QUOTE',
  DECLINE: 'UW_DECLINE_QUOTE',
  UPDATE: 'UW_UPDATE_QUOTE',
  BIND: 'UW_BIND_QUOTE',
  DELETE: 'UW_DELETE_QUOTE',
});

export type QuoteActions = (typeof QUOTE_ACTIONS)[keyof typeof QUOTE_ACTIONS];

export const actionToStatusOptionMapping = {
  [QUOTE_ACTIONS.RELEASE]: [QuoteStatus.READY_STATUS].map(transformToOption()),
  [QUOTE_ACTIONS.DECLINE]: [QuoteStatus.DECLINED_STATUS].map(
    transformToOption()
  ),
  [QUOTE_ACTIONS.UPDATE]: [
    QuoteStatus.INDICATION_STATUS,
    QuoteStatus.REFERRED_STATUS,
    QuoteStatus.IN_REVIEW_STATUS,
    QuoteStatus.EXPIRED_STATUS,
  ].map(transformToOption()),
  [QUOTE_ACTIONS.BIND]: [QuoteStatus.BOUND_STATUS].map(transformToOption()),
  [QUOTE_ACTIONS.DELETE]: [QuoteStatus.INVALID_STATUS].map(transformToOption()),
};
